type TCallback = () => void;
export type TStoreApi<Store> = {
  get: () => Store;
  set: (value: Partial<Store>) => void;
  subscribe: (callback: () => void) => () => void;
};
export default function createFastStore<Store>(initialValue: Store): TStoreApi<Store> {
  const store = { current: initialValue };
  const subscribers = { current: new Set<TCallback>() };

  return {
    get: () => store.current,
    set: (value: Partial<Store>) => {
      store.current = { ...store.current, ...value };
      subscribers.current.forEach((callback) => callback());
    },
    subscribe: (callback: () => void) => {
      subscribers.current.add(callback);
      return () => subscribers.current.delete(callback);
    },
  };
}
